/* TÜV certificates (section wu-tuv). Instance settings: window.WU_CFG[section id]. */
  (function () {
    function initOne(root) {
      if (!root || root.dataset.init) return;
      var C = (window.WU_CFG || {})[root.id] || {}, T = C.t || {};
      root.dataset.init = '1';
      var docs; try { docs = JSON.parse(root.querySelector('[data-cmp-data]').textContent); } catch (e) { return; }
      if (!docs.length) return;
      function pl(n, a, b, c) { n = Math.abs(n); return n === 1 ? a : (n >= 2 && n <= 4 ? b : c); }
      function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
      function el(tag, cls, text) { var x = document.createElement(tag); if (cls) x.className = cls; if (text != null) x.textContent = text; return x; }
      /* same as the Liquid handleize filter */
      function handleize(s) { return String(s).normalize('NFKD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
      function split(m) { var r = /\s*\[(\d{4})\s*-\s*(\d{4})?\]\s*$/.exec(m); return r ? [m.slice(0, r.index), r[1] + '–' + (r[2] || '')] : [m, '']; }
      var collUrl = root.dataset.coll || '/collections';
      var docBar = root.querySelector('.wu-tuv__docs'), docName = root.querySelector('.wu-tuv__doc-name'), pdf = root.querySelector('.wu-tuv__pdf');
      var brandBar = root.querySelector('.wu-cmp__brands'), sum = root.querySelector('.wu-cmp__sum');
      var title = root.querySelector('.wu-cmp__title'), grid = root.querySelector('.wu-cmp__models'), empty = root.querySelector('.wu-cmp__empty'), nolist = root.querySelector('.wu-tuv__nolist');
      var search = root.querySelector('.wu-cmp__search');
      var cur = 0, data = {}, brands = [];
      function docTitle(d) { return d.label + (d.no ? ' ' + d.no : '') + (d.pcd ? ' · ' + d.pcd : ''); }
      function loadTree() {
        var url = root.dataset.url, cache = window.wuTuvFitment = window.wuTuvFitment || {};
        if (!cache[url]) {
          cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
          cache[url].catch(function () { delete cache[url]; });
        }
        return cache[url];
      }
      var n = 0;
      function card(brand, m, withBrand) {
        var p = split(m[0]), b = el('button', 'wu-cmp__model');
        b.type = 'button'; b.dataset.brand = brand; b.dataset.model = m[0];
        b.setAttribute('aria-expanded', 'false');
        b.appendChild(el('span', 'wu-cmp__model-name', (withBrand ? brand + ' ' : '') + p[0]));
        b.appendChild(el('span', 'wu-cmp__model-info', (p[1] ? p[1] + ' · ' : '') + m[1] + ' ' + pl(m[1], T["wu_t.ui2.pl_engine_1"], T["wu_t.ui2.pl_engine_2"], T["wu_t.ui2.pl_engine_5"])));
        return b;
      }
      function render(list, head) {
        grid.textContent = '';
        list.forEach(function (x) { grid.appendChild(card(x[0], x[1], x[2])); });
        title.hidden = !head; if (head) title.innerHTML = head;
        empty.hidden = list.length > 0 || !brands.length;
      }
      function selectBrand(name) {
        brands.forEach(function (b) { var on = b.dataset.brand === name; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
        var ms = data[name] || [];
        render(ms.map(function (m) { return [name, m, false]; }), name ? '<strong>' + esc(name) + '</strong> <span>· ' + ms.length + ' ' + pl(ms.length, T["wu_t.ui2.pl_model_1"], T["wu_t.ui2.pl_model_2"], T["wu_t.ui2.pl_model_5"]) + '</span>' : '');
      }
      function selectDoc(i) {
        cur = i; var d = docs[i]; data = d.b || {};
        [].forEach.call(docBar.children, function (b, j) { b.classList.toggle('is-active', j === i); b.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        docName.textContent = docTitle(d);
        pdf.hidden = !d.pdf; if (d.pdf) pdf.href = d.pdf;
        brandBar.textContent = '';
        var nb = 0, nm = 0, ne = 0;
        Object.keys(data).forEach(function (br) {
          var b = el('button', 'wu-cmp__brand', br); b.type = 'button'; b.setAttribute('role', 'tab'); b.dataset.brand = br;
          b.appendChild(el('span', 'wu-cmp__brand-n', String(data[br].length)));
          brandBar.appendChild(b); nb++; nm += data[br].length;
          data[br].forEach(function (m) { ne += m[1]; });
        });
        brands = [].slice.call(brandBar.children);
        nolist.hidden = nb > 0; brandBar.hidden = !nb; if (search) search.hidden = !nb;
        if (sum) { sum.hidden = !nb; sum.innerHTML = '<strong>' + nb + '</strong> ' + pl(nb, T["wu_t.ui2.pl_brand_1"], T["wu_t.ui2.pl_brand_2"], T["wu_t.ui2.pl_brand_5"]) + ' · <strong>' + nm + '</strong> ' + pl(nm, T["wu_t.ui2.pl_model_1"], T["wu_t.ui2.pl_model_2"], T["wu_t.ui2.pl_model_5"]) + ' · <strong>' + ne.toLocaleString('cs-CZ') + '</strong> ' + pl(ne, T["wu_t.ui2.pl_engine_1"], T["wu_t.ui2.pl_engine_2"], T["wu_t.ui2.pl_engine_5"]); }
        if (search) search.value = '';
        if (root.dataset.first && brands[0]) selectBrand(brands[0].dataset.brand); else selectBrand('');
      }
      docs.forEach(function (d, i) {
        var b = el('button', 'wu-cmp__brand wu-tuv__docb', d.label + (d.no ? ' ' + d.no : ''));
        b.type = 'button'; b.setAttribute('role', 'tab');
        if (d.pcd) b.appendChild(el('span', 'wu-cmp__brand-n', d.pcd));
        b.addEventListener('click', function () { selectDoc(i); });
        docBar.appendChild(b);
      });
      brandBar.addEventListener('click', function (e) {
        var b = e.target.closest('.wu-cmp__brand'); if (!b) return;
        if (search) search.value = '';
        selectBrand(b.classList.contains('is-active') ? '' : b.dataset.brand);
      });
      /* click on a model: conditions and engines (links to collections) under the card across the full row */
      grid.addEventListener('click', function (e) {
        var c = e.target.closest('.wu-cmp__model'); if (!c) return;
        var open = c.getAttribute('aria-expanded') === 'true';
        [].forEach.call(grid.querySelectorAll('.wu-cmp__model[aria-expanded="true"]'), function (x) { x.setAttribute('aria-expanded', 'false'); x.classList.remove('is-open'); });
        var old = grid.querySelector('.wu-cmp__engines'); if (old) old.remove();
        if (open) return;
        c.setAttribute('aria-expanded', 'true'); c.classList.add('is-open');
        var box = el('div', 'wu-cmp__engines wu-tuv__engines', '…'); box.id = root.id + '-e' + (++n);
        c.setAttribute('aria-controls', box.id);
        var cards = [].slice.call(grid.querySelectorAll('.wu-cmp__model')), top = c.offsetTop, after = c;
        cards.forEach(function (x) { if (x.offsetTop === top) after = x; });
        after.after(box);
        var brand = c.dataset.brand, gen = c.dataset.model, docIdx = cur;
        loadTree().then(function (t) {
          var doc = (t || [])[docIdx] || {};
          var items = ((doc.strom || {})[brand] || {})[gen] || [];
          var pod = (doc.podminky || {})[brand + '|' + gen];
          box.textContent = '';
          if (pod && pod.pneu && pod.pneu.length) box.appendChild(el('p', 'wu-tuv__cond', C.tyres + ' ' + pod.pneu.join(', ')));
          if (pod && pod.podminky && pod.podminky.length) box.appendChild(el('p', 'wu-tuv__cond', C.cond + ' ' + pod.podminky.join(' · ')));
          items.forEach(function (v) {
            var parts = String(v).split('|');
            var a = el('a', '', parts[0]);
            a.href = collUrl + '/' + (parts[1] || ('alu-kola-' + handleize(brand + ' ' + gen + ' ' + parts[0])));
            box.appendChild(a);
          });
        }).catch(function () { box.textContent = '–'; });
      });
      if (search) {
        var st = 0;
        search.addEventListener('input', function () { clearTimeout(st); st = setTimeout(function () {
          var q = search.value.toLowerCase().trim();
          if (!q) { var a = brandBar.querySelector('.is-active'); selectBrand(a ? a.dataset.brand : (root.dataset.first && brands[0] ? brands[0].dataset.brand : '')); return; }
          brands.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
          var words = q.split(/\s+/), out = [];
          Object.keys(data).forEach(function (br) { data[br].forEach(function (m) {
            var hay = (br + ' ' + m[0]).toLowerCase();
            if (words.every(function (w) { return hay.indexOf(w) > -1; })) out.push([br, m, true]);
          }); });
          render(out.slice(0, 60), '');
        }, 150); });
        search.addEventListener('focus', function () { loadTree().catch(function () {}); }, { once: true });
      }
      selectDoc(0);
    }
    function init() { Object.keys(window.WU_CFG || {}).forEach(function (id) { if (id.indexOf('WuTuv-') === 0) initOne(document.getElementById(id)); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();
